// extracted by mini-css-extract-plugin
module.exports = {"overlay":"AlertNotify_overlay__38hh4"};